import SubtractBadgeIcon from './SubtractBadgeIcon';
import SubtractIcon from './SubtractIcon';

export default function SubtractIconWithBadge({
  text,
  iconSize = 27,
  className = '',
  onIconClick = (event) => {},
  onBadgeClick = (event) => {}
}: {
  text: string;
  iconSize?: number;
  className?: string;
  onIconClick?: (event) => void;
  onBadgeClick?: (event) => void;
}) {
  return (
    <div className={'flex flex-col flex-start items-center gap-0 ' + className}>
      <SubtractIcon size={iconSize} onClick={onIconClick} />
      <SubtractBadgeIcon text={text} onClick={onBadgeClick} />
    </div>
  );
}
